import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';

import {Form, Card, Row, Col} from "react-bootstrap"
import {AiOutlineEye, AiOutlineEyeInvisible} from 'react-icons/ai'

import { register, authGetClient, register2 } from "../../actions/auth-action";
import { useGetClients } from "../../hooks/useOfCreateUser";
import { useGetLegalEntities, useGetBusinessUnits, useGetJobPositions, useGetClientProductsToCombobox, useGetPartyLeBuTree } from "../../hooks/useOfClient";
import { MessageBar, MessageBarType, Toggle, ComboBox } from '@fluentui/react';
import '../../css/CreateUser.css'
import nnImg from '../../images/nn.png'
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import "../../css/DropDownCheckbox.css";
import "office-ui-fabric-react/dist/css/fabric.css";
import Container from '../../components/ObservableUnits'
import { useGetProfiles } from "../../hooks/useOfManageUserPermission";
import { PARAM_USER_ROLE, PARAM_OBSERVER_ROLE, PARAM_EXTERNAL_ROLE, PARAM_ADMIN_ROLE } from "../../configurations/staticTypes.config";
import { __AccountType, __WhiteEmailDomainList } from "../../common/Dictionaries";
import AuthVerify from "../../components/AuthVerify";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";
//#region Validadores de campos
const isInValidFormControl = (value) => {
  return value === "";
}
const isInValidListFormControl = (value) => {
  return (value === "0" || value === null);
}
const isInValidClient = (value) => {
  return (value === null || value === "0" || value === '');
}
//#endregion

const configureObservableBusinessUnitTree = (nodes = []) => {
	return nodes.map(node => {
		const { disabled, ...nodeWithoutDisabled } = node;

		return {
			...nodeWithoutDisabled,
			className: Number(node.typeId) === 1
				? "non-selectable-node"
				: "",
			children: configureObservableBusinessUnitTree(node.children ?? [])
		};
	});
};

// react-dropdown-tree-select no expone el estado "checked" completo del árbol: el
// selectedNodes que entrega en onChange colapsa cualquier subárbol ya marcado (solo
// entrega el nodo tope), así que no sirve para reconstruir todas las BU marcadas por
// cascada. Estos helpers recorren nuestro propio árbol (el mismo que se le pasa como
// data al Container) para reconstruir el set completo de nodos marcados a partir de
// currentNode, que sí es siempre confiable.
const findNodeById = (nodes, id) => {
	for (const node of nodes || []) {
		if (node.id === id) {
			return node;
		}

		const found = findNodeById(node.children, id);
		if (found) {
			return found;
		}
	}

	return null;
};

const collectNodeAndDescendantIds = (node, acc = []) => {
	acc.push(node.id);
	(node.children || []).forEach(child => collectNodeAndDescendantIds(child, acc));
	return acc;
};

const findAncestorIds = (nodes, targetId, path = []) => {
	for (const node of nodes || []) {
		if (node.id === targetId) {
			return path;
		}

		const found = findAncestorIds(node.children, targetId, [...path, node.id]);
		if (found) {
			return found;
		}
	}

	return null;
};

const collectNemosFromCheckedIds = (nodes, checkedIds, acc = []) => {
	(nodes || []).forEach(node => {
		if (checkedIds.has(node.id) && Number(node.typeId) === 2) {
			acc.push(node.nemo);
		}

		collectNemosFromCheckedIds(node.children, checkedIds, acc);
	});

	return acc;
};

//Agregar flag doble factor habilitado.
//Al crear que se establezca el AAD FBA y 2F.

//Al Editar agregar flag doble factor habilitado.
//Al editar que se establezca el AAD FBA y 2F.

//API Validar fecha de validez de los c digos (Reset Pass y Login 2F), responder mensaje "C digo expirado."

const CreateUser = () => {
	const { t } = useTranslation();

	const { user: currentAuth } = useSelector((state) => state.auth);
	const dispatch = useDispatch();

	const [successful, setSuccessful] = useState(null);
	const [loadingCreate, setLoadingCreate] = useState(false);
	const { message } = useSelector(state => state.message);

	const userClientId = authGetClient();
	const [selectedClientId, setSelectedClientId] = useState(null);

	const [clientList, setClientList] = useState(null);
	useGetClients(clientList, setClientList, true);

	const [legalEntityList, setLegalEntityList] = useState(null);
	useGetLegalEntities(userClientId || selectedClientId, legalEntityList, setLegalEntityList, true);

	const [observableBusinessUnitList, setObservableBusinessUnitList] = useState(null);
	useGetPartyLeBuTree(userClientId || selectedClientId, observableBusinessUnitList, setObservableBusinessUnitList);

	const observableBusinessUnitTree = useMemo(
		() => configureObservableBusinessUnitTree(observableBusinessUnitList ?? []),
		[observableBusinessUnitList]
	);

	// Set propio de ids marcados (ver comentario junto a los helpers de árbol más
	// arriba). Se re-siembra cada vez que cambia el árbol (p.ej. al cambiar de
	// cliente, donde los ids de un árbol no tienen relación con los del anterior).
	const checkedObservableUnitIdsRef = useRef(new Set());

	useEffect(() => {
		const initialChecked = new Set();

		const collectChecked = (nodes) => {
			(nodes || []).forEach(node => {
				if (node.checked) {
					initialChecked.add(node.id);
				}

				collectChecked(node.children);
			});
		};

		collectChecked(observableBusinessUnitTree);
		checkedObservableUnitIdsRef.current = initialChecked;
	}, [observableBusinessUnitTree]);

	const [businessUnitList, setBusinessUnitList] = useState(null);
	useGetBusinessUnits(userClientId || selectedClientId, businessUnitList, setBusinessUnitList, true);

	const [jobPositionList, setJobPositionList] = useState(null);
	useGetJobPositions(userClientId || selectedClientId, jobPositionList, setJobPositionList, true);

	const [userTypeList, setUserTypeList] = useState(null);
	useGetProfiles(userTypeList, setUserTypeList, true)

	const [selectedUserProducts, setSelectedUserProducts] = useState([]);
	const [clientProducts, setClientProducts] = useState(null);
	useGetClientProductsToCombobox(userClientId, clientProducts, setClientProducts)

	
	const [showObservableAreas, setShowObservableAreas] = useState(false)
	const [sendAADInvite, setSendAADInvite] = useState(false)

	const [account, setAccount] = useState({
		username: "",
		password: "",
		confirmpassword: "",

		email: "",
		dnirut: "",
		address: "",
		firstname: "",
		lastname: "",
		phonenumber: "",

		userTypeId: PARAM_USER_ROLE,
		accountType: __AccountType.FBA,
		formTwoFactorEnabled: null,
		userpicturefile: undefined,

		selectedBusinessUnitId: null,
		selectedLegalEntityId: null,
		selectedJobPositionId: null,
		selectedObservableBusinessUnits: [],
		autoGeneratePassword: false
	});

	const [errors, setErrors] = useState({});
	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
	const [showPasswordMessageBar, setShowPasswordMessageBar] = useState(true);
	const form = useRef(null);
	const checkBtn = useRef(null);
	const refProductControl = useRef(null);

	useEffect(() => {
		if (account.accountType === __AccountType.AAD && showPasswordMessageBar) {
			setShowPasswordMessageBar(false);
		}
	}, [account.accountType, showPasswordMessageBar]);

	const [selectedLanguages, setSelectedLanguages] = useState([]);

	const options = [
		{ key: 'EN', text: t('data-lang-lbl-english') },
		{ key: 'ES', text: t('data-lang-lbl-spanish') }
	];

	const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;

	const validateEmail = (email) => {
		if (!email) {
			return t('data-lang-msg-required-field');
		}

		const hasEspecialEmail = __WhiteEmailDomainList.some(domain => email.includes(domain));
		if (!emailRegex.test(email) && !hasEspecialEmail) {
			return t('data-lang-msg-invalid-email');
		}

		return null;
	};

	const validateLanguages = (languages) => {
		if (!languages || languages.length === 0) {
			return t('data-lang-msg-required-field');
		}

		return null;
	};

	const validatePassword = (password, passwordConfirmation) => {
		const errors = {};
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{10,}$)/;

		if (!password) {
			errors.password = t('data-lang-msg-required-field');
		} else if (!regex.test(password)) {
			errors.password = t('data-lang-msg-invalid-password');
		}

		if (!passwordConfirmation) {
			errors.confirmpassword = t('data-lang-msg-required-field');
		} else if (!regex.test(passwordConfirmation)) {
			errors.confirmpassword = t('data-lang-msg-invalid-password');
		}

		if (!errors.password && !errors.confirmpassword && password !== passwordConfirmation) {
			errors.password = '';
			errors.confirmpassword = t('data-lang-msg-notsame-passwordandconfirmation');
		}

		return errors;
	};

	const clearError = (field) => {
		setErrors(prev => {
			const { [field]: removed, ...rest } = prev;
			return rest;
		});
	};

	const onChangeUsername = (e) => {
		const username = e.target.value.replaceAll("\\", "").replaceAll("/", "");
		setAccount(prevState => ({
			...prevState,
			username: username
		}));
		clearError('username');
	};

	const onChangeFirstname = (e) => {
		const firstname = e.target.value;
		setAccount(prevState => ({
			...prevState,
			firstname: firstname
		}));
		clearError('firstname');
	};

	const onChangeLastname = (e) => {
		const lastname = e.target.value;
		setAccount(prevState => ({
			...prevState,
			lastname: lastname
		}));
		clearError('lastname');
	};
	
	const onChangePhonenumer = (e) => {
		const phonenumber = e.target.value;
		setAccount(prevState => ({
			...prevState,
			phonenumber: phonenumber
		}));
		clearError('phonenumber');
	};

	const onChangeDnirut = (e) => {
		const dnirut = e.target.value;
		setAccount(prevState => ({
			...prevState,
			dnirut: dnirut
		}));
		clearError('dnirut');
	};

	const onChangeLanguage = useCallback((event, option) => {
		if (!option) {
			return;
		}

		setSelectedLanguages(prevSelectedLanguages =>
			option.selected ? [...prevSelectedLanguages, option.key] : prevSelectedLanguages.filter(k => k !== option.key),
		);
		clearError('languages');
	}, []);

	const onChangeLegalEntity = (e) => {
		const legalEntityId = e.target.value;
		const isInValid = legalEntityId === "" || legalEntityId === null || legalEntityId === "0";
		clearError('legalEntity');

		if (!isInValid) {
			setAccount(prevState => ({ ...prevState, selectedLegalEntityId: legalEntityId }));
			setShowObservableAreas((legalEntityList.find(x => x.id === parseInt(legalEntityId)).legal_entity_type_id === 1 || legalEntityList.find(x => x.id === parseInt(legalEntityId)).legal_entity_type_id === 2))
		}
		else {
			setAccount(prevState => ({ ...prevState, selectedLegalEntityId: legalEntityId, selectedBusinessUnitId: "0" }));
			setShowObservableAreas(false);
		}
	};

	const onChangeUserType = (e) => {
		//[##]Habilitar cuando se deba usar rol por producto. if (e.target.value !== PARAM_USER_ROLE) {refProductControl.current.style.display = "none"}
		//[##]Habilitar cuando se deba usar rol por producto. else { refProductControl.current.style.display = ""}
		if (e.target.value === PARAM_OBSERVER_ROLE) {
			const mainLeId = legalEntityList.reduce((lower, item) => item.id > 0 && item.id < lower ? item.id : lower, Infinity);
			setAccount(prevState => ({
				...prevState,
				userTypeId: e.target.value,
				selectedLegalEntityId: mainLeId,
				selectedObservableBusinessUnits: null,
				formTwoFactorEnabled: true
			}));
		}
		else {
			if (e.target.value !== PARAM_EXTERNAL_ROLE && e.target.value !== PARAM_USER_ROLE) {
				setAccount(prevState => ({
					...prevState,
					userTypeId: e.target.value,
					selectedLegalEntityId: account.selectedLegalEntityId,
					formTwoFactorEnabled: true
				}));
			}
			else {
				setAccount(prevState => ({
					...prevState,
					userTypeId: e.target.value,
					selectedLegalEntityId: account.selectedLegalEntityId
				}));
			}

		}
	};

	const onAccountAutogeneratePasswordChange = (e, checked) => {
		setAccount(prevState => ({
			...prevState,
			formTwoFactorEnabled: null,
			accountType: __AccountType.FBA,
			password: "",
			confirmpassword: "",
			autoGeneratePassword: checked
		}));
		setErrors(prev => {
			const { password, confirmpassword, ...rest } = prev;
			return rest;
		});
	};

	const onAccountTypeChange = (e, checked) => {
		const nextAccountType = checked ? __AccountType.FBA : __AccountType.AAD;
		setAccount(prevState => ({
			...prevState,
			formTwoFactorEnabled: null,
			accountType: nextAccountType,
			password: "",
			confirmpassword: "",
			autoGeneratePassword: false
		}));
		setErrors(prev => {
			const { password, confirmpassword, ...rest } = prev;
			return rest;
		});
		if (nextAccountType === __AccountType.AAD) {
			setShowPasswordMessageBar(false);
		}
	};

	const onTwoFactorChange = (e, checked) => {
		setAccount(prevState => ({
			...prevState,
			formTwoFactorEnabled: checked,
		}));
	};

	const onSendAAdInviteChange = (e, checked) => {
		setSendAADInvite(checked);
	};

	const onChangeUserProduct = useCallback((event, option) => {
		if (!option) {
			return;
		}

		setSelectedUserProducts(prevSelected =>
			option.selected ? [...prevSelected, option.key] : prevSelected.filter(k => k !== option.key),
		);
	}, []);

	const onChangeBusinessUnit = (e) => {
		const value = e.target.value;
		const businessUnitId = value.split("#")[0];
		clearError('businessUnit');
		setAccount(prevState => ({ ...prevState, selectedBusinessUnitId: value }));
	};

	const onChangeJob = (e) => {
		const jobId = e.target.value;
		clearError('job');
		setAccount(prevState => ({
			...prevState,
			selectedJobPositionId: jobId
		}));
	};

	const onChangeAddress = (e) => {
		const address = e.target.value;
		setAccount(prevState => ({
			...prevState,
			address: address,
		}));
		clearError('address');
	};

	const onChangeEmail = (e) => {
		const email = e.target.value;
		setAccount(prevState => ({
			...prevState,
			email: email,
		}));
		clearError('email');
	};

	const onChangePassword = (e) => {
		const password = e.target.value;
		setAccount(prevState => ({
			...prevState,
			password: password,
		}));
		clearError('password');
	};

	const onChangeConfirmPassword = (e) => {
		const confirmpassword = e.target.value;
		setAccount(prevState => ({
			...prevState,
			confirmpassword: confirmpassword,
		}));
		clearError('confirmpassword');
	};

	const onChangeUserPicture = (e) => {
		const userpicturefile = e.target.files[0];
		setAccount(prevState => ({
			...prevState,
			userpicturefile: userpicturefile,
		}));
	};

	const onChangeClient = (e) => {
		const clientId = e.target.value;
		setSelectedClientId(clientId);
		setObservableBusinessUnitList(null);
		clearError('client');
		setAccount(prevState => ({
			...prevState,
			selectedObservableBusinessUnits: []
		}));

		if (clientId === "" || clientId === null || clientId === "0") {
			setAccount(prevState => ({
				...prevState,
				selectedBusinessUnitId: "0",
				selectedLegalEntityId: "0",
				selectedJobPositionId: "0"
			}));
		}
	};

	const handleClosePasswordMessageBar = () => {
		setShowPasswordMessageBar(false);
	};

	const handleCloseSuccessMessageBar = () => {
		setSuccessful(null);
	};

	const handleShowHidePassword = (e) => {
		if (e === "pass") {
		setShowPassword(!showPassword);
		}
		if (e === "passConfirm") {
		setShowPasswordConfirmation(!showPasswordConfirmation);
		}
	};

	const validateForm = () => {
		const nextErrors = {};
		const clientId = selectedClientId !== null && selectedClientId !== undefined ? selectedClientId : userClientId;

		if (!clientId) {
			nextErrors.client = t('data-lang-msg-required-field');
		}
		if (!account.username) {
			nextErrors.username = t('data-lang-msg-required-field');
		}
		if (!account.firstname) {
			nextErrors.firstname = t('data-lang-msg-required-field');
		}
		if (!account.lastname) {
			nextErrors.lastname = t('data-lang-msg-required-field');
		}
		if (!account.phonenumber) {
			nextErrors.phonenumber = t('data-lang-msg-required-field');
		}
		if (!account.address) {
			nextErrors.address = t('data-lang-msg-required-field');
		}
		if (!account.dnirut) {
			nextErrors.dnirut = t('data-lang-msg-required-field');
		}

		const emailError = validateEmail(account.email);
		if (emailError) {
			nextErrors.email = emailError;
		}

		const languagesError = validateLanguages(selectedLanguages);
		if (languagesError) {
			nextErrors.languages = languagesError;
		}

		const businessUnitId = account.selectedBusinessUnitId !== null ? account.selectedBusinessUnitId.split("#")[0] : "0";
		if (isInValidListFormControl(businessUnitId)) {
			nextErrors.businessUnit = t('data-lang-msg-required-field');
		}
		if (isInValidListFormControl(account.selectedLegalEntityId)) {
			nextErrors.legalEntity = t('data-lang-msg-required-field');
		}
		if (isInValidListFormControl(account.selectedJobPositionId)) {
			nextErrors.job = t('data-lang-msg-required-field');
		}

		if (account.accountType === __AccountType.FBA) {
			const passwordErrors = validatePassword(account.password, account.confirmpassword);
			Object.assign(nextErrors, passwordErrors);
		}

		setErrors(nextErrors);
		return Object.keys(nextErrors).length === 0;
	};

	const hasError = (field) => !!errors[field];
	const getErrorMessage = (field) => errors[field] || "";

	const emailMessageError = getErrorMessage('email');
	const passwordMessageError = getErrorMessage('password');
	const passwordConfirmationMessageError = getErrorMessage('confirmpassword');

	const handleCreate = (e) => {
		e.preventDefault();

		if (loadingCreate) {
			return;
		}

		setSuccessful(null);

		if (!validateForm()) {
			setShowPasswordMessageBar(true);
			return;
		}

		const clientId = userClientId || selectedClientId;
		const businessUnitId = account.selectedBusinessUnitId !== null ? account.selectedBusinessUnitId.split("#")[0] : "0";

		const data = new FormData();
		data.append('ClientId', clientId);
		data.append('Username', account.username);
		data.append('Email', account.email);
		data.append('Password', account.accountType === __AccountType.FBA ? account.password : 'Pw*Ad.');
		data.append('AccType ', account.accountType);
		data.append('FirstName', account.firstname);
		data.append('LastName', account.lastname);
		data.append('PhoneNumber', account.phonenumber + "SSSGGG3PPP" + account.accountType);
		data.append('DniRut', account.dnirut);
		data.append('Address', account.address);
		data.append('UserTypeId', account.userTypeId);
		data.append('Products', clientProducts ? clientProducts.map(item => item.key) : []);
		data.append('LegalEntity', account.selectedLegalEntityId !== null ?
			(legalEntityList ? (legalEntityList.length > 0 ? legalEntityList.find(element => element.id.toString() === account.selectedLegalEntityId.toString()).legal_entity_nemo : "") : "") :
			null
		);
		data.append('BusinessUnit', businessUnitId !== null ?
			(businessUnitList ? (businessUnitList.length > 0 ? businessUnitList.find(element => element.id.toString() === businessUnitId.toString()).business_unit_nemo : "") : "") :
			null
		);
		data.append('Job', account.selectedJobPositionId !== null ?
			(jobPositionList ? (jobPositionList.length > 0 ? jobPositionList.find(element => element.id.toString() === account.selectedJobPositionId.toString()).job_position_nemo : "") : "") :
			null
		);
		data.append('ObservableBusinessUnits', account.selectedObservableBusinessUnits !== null ?
			(account.selectedObservableBusinessUnits ? account.selectedObservableBusinessUnits : []) :
			[]
		);
		data.append('Languages', selectedLanguages);

		const resetForm = () => {
			setSelectedUserProducts([]);
			setObservableBusinessUnitList(null);
			setAccount(prevState => ({
				...prevState,
				username: "",
				password: "",
				confirmpassword: "",
				firstname: "",
				lastname: "",
				phonenumber: "",
				email: "",
				userTypeId: PARAM_USER_ROLE,
				dnirut: "",
				address: "",
				userpicturefile: undefined,
				selectedBusinessUnitId: null,
				selectedLegalEntityId: null,
				selectedObservableBusinessUnits: [],
				selectedJobPositionId: null,
				autoGeneratePassword: false
			}));
		};

		const handleSuccess = () => {
			setShowPasswordMessageBar(false);
			setSuccessful(true);
			setErrors({});
			resetForm();
		};

		const handleError = () => {
			setShowPasswordMessageBar(false);
			setSuccessful(false);
		};

		setLoadingCreate(true);

		if (sendAADInvite !== true) {
			dispatch(register(data))
				.then(handleSuccess)
				.catch(handleError)
				.finally(() => {
					setLoadingCreate(false);
				});
		} else {
			dispatch(register2(sendAADInvite, data, account.username, userClientId))
				.then((response) => {
					if (message === 'data-lang-msg-user-creationsuccess') {
						handleSuccess();
					} else {
						setShowPasswordMessageBar(false);
						setSuccessful(false);
					}
				})
				.catch(handleError)
				.finally(() => {
					setLoadingCreate(false);
				});
		}
	};
	let existenClientes = (clientList !== null ? (userClientId !== null || clientList.find(x => x.clientId !== 0) !== undefined) : false)

	const onChangeObservableBusinessUnit = (currentNode) => {
		const fullNode = findNodeById(observableBusinessUnitTree, currentNode.id);
		if (!fullNode) {
			return;
		}

		const affectedIds = collectNodeAndDescendantIds(fullNode);
		const checkedIds = checkedObservableUnitIdsRef.current;

		if (currentNode.checked) {
			affectedIds.forEach(id => checkedIds.add(id));
		}
		else {
			affectedIds.forEach(id => checkedIds.delete(id));

			const ancestorIds = findAncestorIds(observableBusinessUnitTree, currentNode.id) || [];
			ancestorIds.forEach(id => checkedIds.delete(id));
		}

		setAccount(prevState => ({
			...prevState,
			selectedObservableBusinessUnits: collectNemosFromCheckedIds(observableBusinessUnitTree, checkedIds),
		}));
	};

	return (
		<fieldset disabled={!existenClientes || loadingCreate}>
			<AuthVerify currentToken={currentAuth} />
			{ clientList &&
				<Form onSubmit={handleCreate} ref={form}>          
				<Row>
					<Col sm={12} md={12} lg={12} xl={12}>
					{successful !== null &&
					<MessageBar
						dismissButtonAriaLabel="Close"
						styles={{root:{marginTop: "-96px !important"}}}
						messageBarType={ successful === true ? MessageBarType.success : MessageBarType.error }
						onDismiss={()=> handleCloseSuccessMessageBar()}>
						{t(message)}
					</MessageBar>
					}
					{(showPasswordMessageBar && existenClientes && account.accountType === __AccountType.FBA) &&
					<MessageBar
						dismissButtonAriaLabel="Close"
						styles={{root:{marginTop: "-96px !important"}}}
						messageBarType={MessageBarType.warning}
						onDismiss={()=> handleClosePasswordMessageBar()}>
						<div>
						<b>{t('data-lang-msg-warning')}:</b><br/>
						<ul>
							<li>
							{t('data-lang-msg-password-policy-1')}
							</li>
							<li>
							{t('data-lang-msg-password-policy-2')}
							</li>
							<li>
							{t('data-lang-msg-password-policy-3')}
							</li>
							<li>
							{t('data-lang-msg-password-policy-4')}
							</li> 
							<li>
							{t('data-lang-msg-password-policy-5')}
							</li> 
						</ul>                
						</div>
					</MessageBar>
					}
					{(!existenClientes) &&
					<MessageBar
						dismissButtonAriaLabel="Close"
						styles={{root:{marginTop: "-96px !important", height: "100px"}}}
						messageBarType={ MessageBarType.error }
						onDismiss={()=> handleCloseSuccessMessageBar()}>
						{
						<>
							<b>{t('data-lang-msg-warning')}: </b>
							<p>{t('data-lang-msg-noclient-created')}</p>
						</>
						}
					</MessageBar>
					}
					</Col>
					<Col sm={12} md={12} lg={12} xl={12}>
					<Card className="rounded-3 border card">
						<Card.Header>
						<Row>
							<Col>
							<Card.Title style={{ whiteSpace: "nowrap" }}>
								<h4 style={{float:"left"}}><b>{t('data-lang-pagename-createuser')}</b>:&nbsp;</h4><h5 className="pt-1">{t('data-lang-boxname-personalinformation')}</h5>
							</Card.Title>
							</Col>
						</Row>
						</Card.Header>
						<div className="mx-auto d-block d-sm-block d-md-none d-lg-none pt-4">  
						<img alt="nn1" className="rounded-circle" width={125} src={nnImg}></img>
						</div>
						<div className="card-horizontal">
						<div className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
							<img alt="nn2" className="rounded-circle" width={125} src={nnImg}></img>
						</div>
						<Card.Body className="col-xs-12">
							<Row>
							{userClientId === null && 
								<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-client')}</Form.Label>
								{clientList && (
									<>
										<Form.Select
										className="form-control"
										onChange={onChangeClient}
										value={selectedClientId ?? '0'}
										isInvalid={hasError('client')}
										>
										{ clientList.map((client, index) => <option key={index} value={client.id}>{client.name}</option>)}
										</Form.Select>
										{
										errors.client &&
										<div className="invalid-feedback">
											{t('data-lang-msg-required-field')}
										</div>
										}
									</>
								)}
								</Col>
							}
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-dnirut')}</Form.Label>
								<Form.Control
								type="text"
								className="form-control"
								name="dnirut"
								value={account.dnirut || ''}
								onChange={onChangeDnirut}
								isInvalid={hasError('dnirut')}
								placeholder=""
								autoComplete="off"
								/>
								{
								errors.dnirut &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-firstname')}</Form.Label>
								<Form.Control
								type="text"
								className="form-control"
								name="firstname"
								value={account.firstname || ''}
								onChange={onChangeFirstname}
								isInvalid={hasError('firstname')}
								placeholder="Jhon"
								autoComplete="off"
								/>
								{
								errors.firstname &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-lastname')}</Form.Label>
								<Form.Control
								type="text"
								className="form-control"
								name="lastname"
								value={account.lastname || ''}
								onChange={onChangeLastname}
								isInvalid={hasError('lastname')}
								placeholder="Doe"
								autoComplete="off"
								/>
								{
								errors.lastname &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-phonenumber')}</Form.Label>
								<Form.Control
								type="text"
								className="form-control"
								name="phonenumber"
								value={account.phonenumber || ''}
								onChange={onChangePhonenumer}
								isInvalid={hasError('phonenumber')}
								placeholder="9 12345678"
								autoComplete="off"
								/>
								{
								errors.phonenumber &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-address')}</Form.Label>
								<Form.Control
								type="text"
								className="form-control"
								name="address"
								value={account.address || ''}
								onChange={onChangeAddress}
								isInvalid={hasError('address')}
								placeholder=""
								autoComplete="off"
								/>
								{
								errors.address &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-languages')}</Form.Label>
								<ComboBox
								disabled={!existenClientes}
								multiSelect
								selectedKey={selectedLanguages}
								allowFreeform={false}
								options={options}
								isInvalid={hasError('languages')}
								onChange={onChangeLanguage}
								required={true}
								/>
								{
								errors.languages &&
								<div style={{display: "block"}} className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							{false && <Col xs={12} sm={12} md={12} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-userpicture')}</Form.Label>
								<Form.Control
								type="file"
								className="form-control"
								name="inputUserPicture"
								id="inputUserPicture"
								onChange={onChangeUserPicture}
								accept="image/*"
								/>
							</Col>}
							<Col xs={12} sm={12} md={4} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-usertype')}</Form.Label>
								<Form.Select
									className="form-control"
									onChange={onChangeUserType}
									value={(account.userTypeId ? account.userTypeId : undefined) || undefined}
									isInvalid={hasError('userType')}
									>
									{
									userTypeList ?
										userTypeList.filter(x => isNullUndefinedOrEmpty(currentAuth.profile.find(x => x === "sAdmin")) ? x.name !== "Admin" : true).map((_userType, index) => <option key={index} value={`${_userType.id}`}>{_userType.name}</option>)
										: <></>
									}
								</Form.Select>
							</Col>
							<Col xs={6} sm={6} md={4} lg={4} xl={2} >
								<Form.Label>&nbsp;</Form.Label>
								<Toggle
								checked={ account.accountType === __AccountType.FBA }
								onChange={ onAccountTypeChange }
								role="checkbox"
								label={ t('data-lang-lbl-accounttype') }
								onText={ t('data-lang-lbl-fba') }
								offText={ t('data-lang-lbl-aad') }
								styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}, container: {paddingTop: "7px"}} }
								/>
							</Col>
							<Col xs={6} sm={6} md={4} lg={12} xl={2} >
								<Form.Label>&nbsp;</Form.Label>
								<Toggle
								checked={ account.formTwoFactorEnabled !== null ? account.formTwoFactorEnabled : false }
								onChange={ onTwoFactorChange }
								role="checkbox"
								label={ t('data-lang-lbl-twofactor') }
								disabled={account.accountType === __AccountType.AAD || (account.userTypeId !== PARAM_EXTERNAL_ROLE && account.userTypeId !== PARAM_USER_ROLE)}
								onText={ t('data-lang-btn-enabled') }
								offText={ t('data-lang-btn-disabled') }
								styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}, container: {paddingTop: "7px"}} }
								/>
							</Col>
							<Col xs={6} sm={6} md={4} lg={12} xl={2} >
								<Form.Label>&nbsp;</Form.Label>
								<Toggle
									checked={ sendAADInvite }
									onChange={ onSendAAdInviteChange }
									role="checkbox"
									label={ t('data-lang-lbl-sendinvite') }
									disabled={account.accountType !== __AccountType.AAD}
									onText={ t('data-lang-btn-enabled') }
									offText={ t('data-lang-btn-disabled') }
									styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}, container: {paddingTop: "7px"}} }
								/>
							</Col>
							{
								false &&
								<Col ref={refProductControl} style={{display: "none"}} xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-productasociation')}</Form.Label>
								<ComboBox
									multiSelect
									selectedKey={selectedUserProducts}
									allowFreeform={false}
									options={clientProducts}
									onChange={onChangeUserProduct}
									required={true}
								/>
								</Col>
							}
							</Row>
						</Card.Body>
						</div>
						<Card.Footer>
						</Card.Footer>
					</Card>
					</Col>
					<Col sm={12} md={12} lg={12} xl={12}>
					<Card className="rounded-3 border card" style={{width: "100%", display: (existenClientes ? "block" : "none")}}>
						<Card.Header>
							<Card.Title>
							<h4><b>{t('data-lang-boxname-accountinformation')}</b></h4>
							</Card.Title>
						</Card.Header>
						<Card.Body className="col-xs-12">
						<Row style={{padding: "15px 15px 15px 0"}}>
							<Col xs={12} sm={6} md={6} lg={6} xl={3}>
							<Form.Label>{t('data-lang-lbl-username')}</Form.Label>
							<Form.Control
								type="text"
								className="form-control"
								name="username"
								value={account.username || ''}
								onChange={onChangeUsername}
								isInvalid={hasError('username')}
								autoComplete="off"
							/>
							{
								errors.username &&
								<div className="invalid-feedback">
								{t('data-lang-msg-required-field')}
								</div>
							}
							</Col>
								<Col xs={6} sm={6} md={4} lg={4} xl={2} >
									<Form.Label>&nbsp;</Form.Label>
									<Toggle
										checked={ account.autoGeneratePassword === true }
										onChange={ onAccountAutogeneratePasswordChange }
										role="checkbox"
										label={ t('data-lang-lbl-autogeneratepassword') }
										onText={ t('data-lang-lbl-yes') }
										offText={ t('data-lang-lbl-no') }
										styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}, container: {paddingTop: "7px"}} }
									/>
								</Col>


								<Col xs={12} sm={6} md={6} lg={6} xl={3} style={{zIndex: "0"}}>
								<Form.Label>{t('data-lang-lbl-password')}</Form.Label>
								<div className="input-group mb-3">
									<Form.Control
									type={ showPassword ? "text" : "password" }
									className="form-control"
									name="password"
									value={account.password || ''}
									onChange={onChangePassword}
									disabled={account.accountType === __AccountType.AAD || account.autoGeneratePassword === true}
									isInvalid={hasError('password')}
									/>
									<span className="input-group-text" onKeyDown={() => handleShowHidePassword("pass")} onClick={() => handleShowHidePassword("pass")} role="button" tabIndex={-1}>
									{!showPassword && <AiOutlineEyeInvisible />}
									{showPassword && <AiOutlineEye />}
									</span>
									{
									errors.password &&
									<div className="invalid-feedback">
										{passwordMessageError}
									</div>
									}
								</div>
								</Col>
								<Col xs={12} sm={6} md={6} lg={6} xl={3} style={{zIndex: "0"}}>
								<Form.Label>{t('data-lang-lbl-passwordconfirmation')}</Form.Label>
								<div className="input-group mb-3">
								<Form.Control
									type={ showPasswordConfirmation ? "text" : "password" }
									className="form-control"
									name="confirmpassword"
									value={account.confirmpassword || ''}
									onChange={onChangeConfirmPassword}
									disabled={account.accountType === __AccountType.AAD}
									isInvalid={hasError('confirmpassword')}
								/>
								<span className="input-group-text" onClick={() => handleShowHidePassword("passConfirm")}>
									{!showPasswordConfirmation && <AiOutlineEyeInvisible />}
									{showPasswordConfirmation && <AiOutlineEye />}
								</span>
								{
									errors.confirmpassword &&
									<div className="invalid-feedback">
									{passwordConfirmationMessageError}
									</div>
								}
								</div>
								</Col>
							<Col xs={12} sm={6} md={6} lg={6} xl={3}>
							<Form.Label>{t('data-lang-lbl-email')}</Form.Label>
							<Form.Control
								type="text"
								className="form-control"
								name="email"
								value={account.email}
								onChange={onChangeEmail}
								isInvalid={hasError('email')}
								autoComplete="off"
							/>
							{
								errors.email &&
								<div className="invalid-feedback">
								{emailMessageError}
								</div>
							}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-job')}</Form.Label>
								<Form.Select
								className="form-control"
								onChange={onChangeJob}
								disabled={existenClientes ? (selectedClientId !== "0" ? (jobPositionList !== null ? (jobPositionList.length > 0 ? false : true) : true) : true) : true}
								value={(account.selectedJobPositionId ? account.selectedJobPositionId : undefined) || '0'}
								isInvalid={hasError('job')}
								>
								{ jobPositionList ? jobPositionList.map((jobPosition, index) => <option key={index} value={jobPosition.id}>{jobPosition.name}</option>) : <></>}
								</Form.Select>
								{
								errors.job &&
								<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
								</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
							<Form.Label>{t('data-lang-lbl-legalentity')}</Form.Label>
								<Form.Select
									className="form-control"
									onChange={onChangeLegalEntity}
									disabled={existenClientes ? (selectedClientId !== "0" ? (legalEntityList !== null ? (legalEntityList.length > 0 ? (account.userTypeId === PARAM_OBSERVER_ROLE? true : false) : true) : true) : true) : true}
									value={(account.selectedLegalEntityId ? account.selectedLegalEntityId : undefined) || '0'}
									isInvalid={hasError('legalEntity')}
									>
									{
										(legalEntityList ?
										legalEntityList.map((legalEntity, index) => 
											<option key={index} value={legalEntity.id}>
											{ legalEntity.id !== 0 ? `${legalEntity.legal_entity_code}: ${legalEntity.name}` : legalEntity.name }
											</option>) : <></>)
									}
								</Form.Select>
								{
									errors.legalEntity &&
									<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
									</div>
								}
							</Col>
							<Col xs={12} sm={6} md={6} lg={4} xl={4}>
								<Form.Label>{t('data-lang-lbl-businessunit')}</Form.Label>
								<Form.Select
									className="form-control"
									onChange={onChangeBusinessUnit}
									disabled={existenClientes ? (selectedClientId !== "0" ? (businessUnitList !== null ? (businessUnitList.length > 0 ? false : true) : true) : true) : true}
									value={(account.selectedBusinessUnitId ? account.selectedBusinessUnitId : undefined) || '0'}
									isInvalid={hasError('businessUnit')}
									>
									{
									businessUnitList ?
									(account.selectedLegalEntityId !== null ?
										businessUnitList.filter(x => x.id === 0 || x.legal_entity_id === parseInt(account.selectedLegalEntityId)).map((businessUnit, index) => <option key={index} value={`${businessUnit.id}#${businessUnit.business_unit_parent_id}`}>{businessUnit.name}</option>)
										: <></>) :
									<></>
									}
								</Form.Select>
								{
									hasError('businessUnit') &&
									<div className="invalid-feedback">
									{t('data-lang-msg-required-field')}
									</div>
								}
							</Col>
							{
								(![PARAM_OBSERVER_ROLE.toLocaleLowerCase(), PARAM_ADMIN_ROLE.toLocaleLowerCase()].includes(account.userTypeId.toLocaleLowerCase()) &&
								showObservableAreas) &&
								<Col xs={12} sm={6} md={6} lg={8} xl={8}>
									<Form.Label>{t('data-lang-lbl-observablearea')}</Form.Label>
									<Container
										data={observableBusinessUnitTree}
										mode="multiSelect"
										disabled={
											!existenClientes ||
											selectedClientId === "0" ||
											!observableBusinessUnitList?.length
										}
										className="dropdown-checkbox"
										texts={{ placeholder: t('data-lang-lbl-choose') }}
										onChange={onChangeObservableBusinessUnit}
									>
									</Container>
									{
									hasError('businessUnit') &&
									<div className="invalid-feedback">
										{t('data-lang-msg-required-field')}
									</div>
									}
								</Col>
							}
						</Row>
						</Card.Body>
						<Card.Footer>
						</Card.Footer>
					</Card>
					</Col>
				</Row>

				<Row className="d-md-flex justify-content-md-end">
					<Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
					<button data-component-id="btnCreate" type="submit" className="btn btn-primary col-12 mt-2" disabled={loadingCreate}>
						{ loadingCreate && (<span className="spinner-border spinner-border-sm"></span>) }
						<span> {t('data-lang-btn-create')} </span>
					</button>
					</Col>
					<Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
					<Link to="/admin" onClick={(e) => loadingCreate && e.preventDefault()}>
						<button data-component-id="btnGoHome" type="button" className="btn btn-primary col-12 mt-2" disabled={loadingCreate}>{t('data-lang-btn-gohome')}</button>
					</Link>
					</Col>
				</Row>
				<Form.Check style={{ display: "none" }} ref={checkBtn} />
				</Form>
			}
			{ !clientList &&
				<>
				<Card className="rounded-3 border card" style={{height: "300px"}}>
					<Card.Body>
					<Shimmer
						customElementsGroup={
						<div>
							<div style={{ display: 'flex' }}>
								<ShimmerElementsGroup
									shimmerElements={[
										{ type: ShimmerElementType.circle, height: 125 },
										{ type: ShimmerElementType.gap, width: 16, height: 125 },
									]}
								/>
								<ShimmerElementsGroup
									flexWrap
									width="100%"
									shimmerElements={[
										{ type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
										{ type: ShimmerElementType.line, width: '100%', height: 10 },
										{ type: ShimmerElementType.line, width: '100%', height: 10 },
										{ type: ShimmerElementType.line, width: '100%', height: 10 },
										{ type: ShimmerElementType.gap, width: '100%', height: 25 },
									]}
								/>
							</div>
							<div style={{ display: 'flex' }}>
							<ShimmerElementsGroup
								flexWrap
								width="100%"
								shimmerElements={[
									{ type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.gap, width: '100%', height: 25 },
								]}
							/>
							</div>
						</div>
						}
						styles={{
							root: {
								width:"100%",
								height:"150px",
								backgroundColor: "white"}
							}
						}
						className="pt-4"
						isDataLoaded={clientList !== null}>
					</Shimmer>
					</Card.Body>
				</Card>
				<Card className="rounded-3 border card" style={{height: "300px"}}>
					<Card.Body>
					<Shimmer
						customElementsGroup={
						<div>
							<div style={{ display: 'flex' }}>
							<ShimmerElementsGroup
								flexWrap
								width="100%"
								shimmerElements={[
									{ type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.gap, width: '100%', height: 25 },
								]}
							/>
							</div>
							<div style={{ display: 'flex' }}>
							<ShimmerElementsGroup
								flexWrap
								width="100%"
								shimmerElements={[
									{ type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.line, width: '100%', height: 10 },
									{ type: ShimmerElementType.gap, width: '100%', height: 25 },
								]}
							/>
							</div>
						</div>
						}
						styles={{
							root: {
								width:"100%",
								height:"150px",
								backgroundColor: "white"}
							}
						}
						className="pt-4"
						isDataLoaded={clientList !== null}>
					</Shimmer>
					</Card.Body>
				</Card>
				</>
			}
		</fieldset>
	);
};

export default CreateUser;